import {Navigate, Route} from "react-router";
import {RequireAuth} from "../authentication/routing/RequireAuth";
import {CategoryModuleLayout} from "../pages/category-profile/CategoryModuleLayout";
import {ExploreCategoriesPage} from "../pages/category-profile/explore/ExploreCategoriesPage";
import {CategoryProfileLayout} from "../pages/category-profile/profile/CategoryProfileLayout";
import {CategorySettingsPage} from "../pages/category-profile/settings/CategorySettingsPage";
import {BenchmarksTab} from "../pages/category-profile/profile/tabs/BenchmarksTab";
import {ExternalSignalsTab} from "../pages/category-profile/profile/tabs/ExternalSignalsTab";
import {MarketIndexTab} from "../pages/category-profile/profile/tabs/MarketIndexTab";
import {OverviewTab} from "../pages/category-profile/profile/tabs/OverviewTab";
import {ShouldCostTab} from "../pages/category-profile/profile/tabs/ShouldCostTab";
import {StrategyTab} from "../pages/category-profile/profile/tabs/StrategyTab";
import {SuppliersTab} from "../pages/category-profile/profile/tabs/SuppliersTab";
import {ContractsTab} from "../pages/category-profile/profile/tabs/ContractsTab";
import {TransactionsTab} from "../pages/category-profile/profile/tabs/TransactionsTab";
import {routes} from "./routes";

/**
 * Explore Categories (`/data/:id/categories`), the Category Profile (`.../categories/profile/:tab?path=`) and its
 * staff-only settings (`.../categories/settings`).
 */
export const categoryProfileRoute = (
    <Route path={routes.category_explore} element={<RequireAuth><CategoryModuleLayout/></RequireAuth>}>
        <Route index element={<ExploreCategoriesPage/>}/>
        <Route path="settings" element={<CategorySettingsPage/>}/>
        <Route path="profile" element={<CategoryProfileLayout/>}>
            <Route index element={<Navigate to="overview" replace/>}/>
            <Route path="overview" element={<OverviewTab/>}/>
            <Route path="strategy" element={<StrategyTab/>}/>
            <Route path="suppliers" element={<SuppliersTab/>}/>
            <Route path="contracts" element={<ContractsTab/>}/>
            <Route path="transactions" element={<TransactionsTab/>}/>
            <Route path="should-cost" element={<ShouldCostTab/>}/>
            <Route path="market-index" element={<MarketIndexTab/>}/>
            <Route path="benchmarks" element={<BenchmarksTab/>}/>
            <Route path="external-signals" element={<ExternalSignalsTab/>}/>
            <Route path="*" element={<Navigate to="../overview" replace/>}/>
        </Route>
    </Route>
);
